'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var displayReasons = require('./displayReasons.js');
var language_en_US = require('../../../consts/language_en_US.js');
var SelectList = require('../../../components/SelectList/SelectList.js');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/LocationCard.js');
require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var LanguageProvider = require('../../../providers/LanguageProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const tempLanguageKeys = {
  returnsReasonsListTitle: language_en_US["default"].returnsReasonsListTitle,
  returnsReasonsListTitleSecondary: language_en_US["default"].returnsReasonsListTitleSecondary
};
const ReturnReasonsList = _ref => {
  let {
    reasons,
    onChange,
    selection
  } = _ref;
  const reasonNodes = displayReasons["default"]({
    reasons,
    selection
  }).map((_ref2, i) => {
    let {
      id,
      name
    } = _ref2;
    return {
      label: `${name || id || i}`,
      value: `${id ?? name ?? ''}`
    };
  });
  const handleChange = e => {
    const selectedReason = reasons.find(reason => reason.id === e) || reasons.find(reason => reason.name === e);
    if (selectedReason) {
      onChange(selectedReason);
    }
  };
  const currentSelection = reasons.find(reason => {
    var _selection;
    return (reason === null || reason === void 0 ? void 0 : reason.id) === ((_selection = selection[selection.length - 1]) === null || _selection === void 0 ? void 0 : _selection.id);
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, selection.length === 0 ? /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsListTitle"
  }) : /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsListTitleSecondary"
  })), /*#__PURE__*/React__default["default"].createElement(SelectList["default"], {
    onChange: handleChange,
    selection: currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.id,
    options: reasonNodes
  }));
};
const ReturnReasonsListWrapped = props => {
  const {
    returnsReasonsListTitle,
    returnsReasonsListTitleSecondary
  } = nthHookTranslations.useTranslations();
  const title = returnsReasonsListTitle ?? tempLanguageKeys.returnsReasonsListTitle;
  const secondaryTitle = returnsReasonsListTitleSecondary ?? tempLanguageKeys.returnsReasonsListTitleSecondary;
  return /*#__PURE__*/React__default["default"].createElement(LanguageProvider.LanguageProvider, {
    language: {
      returnsReasonsListTitle: title,
      returnsReasonsListTitleSecondary: secondaryTitle
    }
  }, /*#__PURE__*/React__default["default"].createElement(ReturnReasonsList, props));
};

exports["default"] = ReturnReasonsListWrapped;
